import { getObjectDiff } from "@azu-business/editor-v3";
import { TLF_VIEW_MODES } from "aic";
import { omitEditableMetadata } from "contexts/appsettings/omitEditableMetadata";
import { eHierarchyLevel, eTlfItemType } from "functions/api/enums";
import { omit } from "lodash";
import { TlfContextProps } from "./interface";
import { toTlfChangedData } from "./toTlfChangedData";

/** Derived TLF fields excluded from dirty comparison outside variant patch catalogues. */
const excludedFields = new Set(["relationships", "isLocked", "contentProps", "coreTrafficLight"]);

/**
 * Updates the dirty flag against the persisted baseline and validates TLF presentation.
 *
 * @param state - The current TLF context state
 */
export const checkChanged = (state: TlfContextProps) => {
  // Changed memo
  const currentData = toTlfChangedData(state.tlfData);
  const savedData = toTlfChangedData(state.savedTlfData);
  const current = omitEditableMetadata(
    currentData === null ? null : omit(currentData, ["comments"]),
    [],
    excludedFields,
  );
  const saved = omitEditableMetadata(
    savedData === null ? null : omit(savedData, ["comments"]),
    [],
    excludedFields,
  );
  const changed = getObjectDiff(current, saved);
  // Get changed (unsaved) flag
  state.changed = changed !== undefined;
  // Check if traffic lights should be hidden initially
  if (
    state.tlfData?.primaryHierarchyLevel === eHierarchyLevel.Report &&
    state.tlfData?.coreTrafficLightSwitch === "DoNotCalculate" &&
    ("tocOriginTrafficLight" in state.tlfData
      ? state.tlfData.tocOriginTrafficLight === "FromScratch" ||
        state.tlfData.tocOriginTrafficLight === "FromBasicLayout" ||
        state.tlfData.type === eTlfItemType.figure ||
        state.tlfData.type === eTlfItemType.v1figure
      : true)
  )
    state.showTrafficLights = false;
  // Check if view mode is ok
  if (
    state.tlfViewMode.showOnlyForTlfTypes &&
    state.tlfData?.type &&
    !state.tlfViewMode.showOnlyForTlfTypes.has(state.tlfData.type)
  ) {
    state.tlfViewMode = TLF_VIEW_MODES[0];
  }
};
